import { all } from 'redux-saga/effects';
import Auth from './Auth';
import Request from './Request';
import Notification from './Notification';
import Pricing from './Pricing';
import Structure from './Structure';
import Settings from './Settings';

export default function* rootSaga(getState) {
  yield all([
    Auth(),
    Request(),
    Notification(),
    Pricing(),
    Structure(),
    Settings()
  ]);
}
